'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");
require('../../company/checklist/CompanyChecklistService.js');
require('../../company/publications/order/CompanyPublicationOrderService.js');

var LIMIT = 21;

function CompanyGuestFoldersDetailCtrl(
  $scope,
  publication,
  files,
  checklists,
  children,
  order,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyPublicationService,
  CompanyPublicationFileService,
  $sce,
  config,
  activityService
) {
  $scope.publication         = publication;
  $scope.files               = files.slice(0, LIMIT);
  $scope.checklists          = checklists;
  $scope.translations        = translations;
  $scope.children            = children;
  $scope.order               = order;
  $scope.activityService     = activityService;
  $scope.currentPage         = $stateParams.page|0;
  $scope.hasMore             = files.length > LIMIT;
  $scope.searchFileStr       = $stateParams.searchFile || "";

  $scope.setDefaultColor = function() {
    $scope.children.forEach(function(c,i){
      if (!c.category) {
        $scope.children[i].category = {};
        $scope.children[i].category.color = 4279856278; // #196c96
      }
    });
  };

  $scope.setDefaultColor();

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/folders/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestFoldersDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
    return checklistService.query({
      companyId: $stateParams.companyId,
      relativeID: $stateParams.publicationId
    }).$promise;
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit: LIMIT + 1,
      q: $stateParams.searchFile || "",
      offset: ($stateParams.page|0) * LIMIT
    }).$promise;
  }],
  order: ['CompanyCustomersService', '$stateParams', 'publication' , function(CompanyCustomersService, $stateParams, publication){
    if (publication.features.currentCustomerId) {
        return CompanyCustomersService.get({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        customerId: publication.features.currentCustomerId
      }).$promise;
    }
    return false;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 20}).$promise;
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestFoldersDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestFoldersDetailCtrl', [
  '$scope',
  'publication',
  'files',
  'checklists',
  'children',
  'order',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyPublicationService',
  'CompanyPublicationFileService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestFoldersDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/folders/CompanyGuestFoldersDetailCtrl.js
// module id = 291
// module chunks = 0